import { h } from 'preact';
import React, { Component } from 'react';

import { Sanitize } from '../Sanitize/Sanitize';
import { formatDescription } from '../../util';

import './Stacks.css';

export default class Accordion extends Component {
  state = {
    open: false
  }
  toggleAccordion = () => {
    const panel = this.panel;
    const open = !this.state.open;
    this.setState({ open })
    if (!open) {
      panel.style.maxHeight = null;
    } else {
      panel.style.maxHeight = panel.scrollHeight + 'px';
    }
  }

  render() {
    const { stack, loading } = this.props;
    const { open } = this.state;
    const description = (stack.type === 'CUSTOM')
      ? (
        <p
          style={{ ...this.props.panelStyles }}
          dangerouslySetInnerHTML={{ __html: Sanitize({ html: stack.description }) }}
        />
      )
      : (
        <p style={{ ...this.props.panelStyles }}>
          {formatDescription(stack.description)}
        </p>
      );

    return (
      <div
        tabIndex="0"
        className="stack"
        onKeyDown={e => e.keyCode == 13 && (loading ? null : this.toggleAccordion())}
      >
        <button
          tabIndex="-1"
          className={open ? 'accordion active' : 'accordion'}
          style={this.props.accordionStyles}
          onClick={loading ? null : this.toggleAccordion}
        >
          {stack.name}
          {loading ? null : <span className={open ? 'chevron up' : 'chevron down'} />}
        </button>
        <div ref={c => this.panel = c} className="panel">
          {description}
        </div>
      </div>
    );
  }
}
